import "./chat.css";
import { EditDp, Navbar } from "../Components";
import CustomTop from "./CustomTop";
import "bootstrap/dist/css/bootstrap.min.css";
import { BiSearch } from "react-icons/bi";
import { MdOutlineArrowBackIos } from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../Utils/supabaseClient";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { UpgradePage } from "./UpgradePage";
import { Modal } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";

import { CraftsModal } from "./CraftsModal";
import Disclaimer from "../Utils/Disclaimer";

const MessagesPage = () => {
  const { hcc_id: otherHccId } = useParams();
  let profile_data = JSON.parse(localStorage.getItem("profile_data"));

  const navigate = useNavigate();
  const myHccId = localStorage.getItem("hcc_id");

  const [showApply, setshowApply] = useState(false);
  const [profilePic, setProfilepic] = useState(false);
  const [UpgradeShow, setUpgradeShow] = useState(false);
  const [ScreenVisbile, setScreenVisbile] = useState("plans");

  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const chatRef = useRef(null);
  const textareaRef = useRef(null); // ← for auto-resizing textarea

  const fetchMessages = async () => {
    const { data } = await supabase
      .from("messages")
      .select("*")
      .or(
        `and(sender_id.eq.${myHccId},receiver_id.eq.${otherHccId}),and(sender_id.eq.${otherHccId},receiver_id.eq.${myHccId})`
      )
      .order("created_at", { ascending: false });

    if (data) {
      const reversed = data.reverse();
      setMessages(reversed);

      // ✅ Mark all messages as read (only those sent to me and unread)
      const unreadIds = reversed
        .filter((msg) => msg.sender_id === otherHccId && !msg.read_at)
        .map((msg) => msg.id);

      if (unreadIds.length) {
        await supabase
          .from("messages")
          .update({ read_at: new Date().toISOString() })
          .in("id", unreadIds);
      }

      setChatList((prev) =>
        prev.map((chat) =>
          chat.hcc_id === otherHccId ? { ...chat, unread_count: 0 } : chat
        )
      );
    }
  };

  useEffect(() => {
    if (messageText === "" && textareaRef.current) {
      textareaRef.current.style.height = "auto";
    }
  }, [messageText]);

  const handleSend = async () => {
    if (!messageText.trim()) return;

    const timestamp = new Date().toISOString();
    const tempId = `temp-${Date.now()}`;

    const optimisticMessage = {
      id: tempId,
      sender_id: myHccId,
      receiver_id: otherHccId,
      content: messageText,
      created_at: timestamp,
      isOptimistic: true,
    };

    setMessages((prev) => [...prev, optimisticMessage]);
    setMessageText("");

    const { data, error } = await supabase
      .from("messages")
      .insert({
        sender_id: myHccId,
        receiver_id: otherHccId,
        content: optimisticMessage.content,
      })
      .select()
      .single();

    if (!error && data) {
      setMessages((prev) =>
        prev.map((msg) => (msg.id === tempId ? data : msg))
      );
    }
    // Update chat list manually after sending a new message
    const exists = chatList.find((c) => c.hcc_id === otherHccId);
    if (!exists) {
      const { data: previewData, error: previewErr } = await supabase.rpc(
        "get_chat_preview",
        {
          my_hcc_id: myHccId,
          other_hcc_id: otherHccId,
        }
      );

      if (previewErr) {
        console.error(
          "Failed to fetch chat preview after sending:",
          previewErr.message
        );
      } else if (previewData?.length) {
        const newChat = {
          ...previewData[0],
          hcc_id: previewData[0].other_hcc_id || otherHccId,
        };
        setChatList((prev) => [...prev, newChat]);
      }
    } else {
      // If already in list, update last message and timestamp
      setChatList((prev) =>
        prev.map((chat) =>
          chat.hcc_id === otherHccId
            ? {
              ...chat,
              last_message_content: data.content,
              last_message_created_at: data.created_at,
            }
            : chat
        )
      );
    }
  };

  const subscribeToMessages = () => {
    const channel = supabase
      .channel("chat-realtime")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "messages",
          filter: `receiver_id=eq.${myHccId}`,
        },
        (payload) => {
          const message = payload.new;
          if (message.sender_id === otherHccId) {
            setMessages((prev) => [...prev, message]);
          }
        }
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  };

  useEffect(() => {
    if (otherHccId) {
      fetchMessages();
      const unsub = subscribeToMessages();
      return unsub;
    }
  }, [otherHccId]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  const [fallbackUser, setFallbackUser] = useState(null);

  const formatLastSeen = (timestamp) => {
    if (!timestamp) return "";
    const last = new Date(timestamp);
    const now = new Date();
    const diff = Math.floor((now - last) / 1000);
    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return last.toLocaleString();
  };

  const handleTextareaInput = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = Math.min(textarea.scrollHeight, 120) + "px"; // ~5 lines
  };

  const handleUpgradeClose = () => {
    setUpgradeShow(false);
    setScreenVisbile("plans");
  };
  const handleprofilpicclose = () => {
    setProfilepic(false);
  };
  const handleClose = () => {
    setshowApply(false);
  };

  const UpgradeCheck = () => {
    handleSend();
  };

  const convertLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
      const safeUrl = url.replace(/"/g, "&quot;"); // basic XSS protection
      return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const [chatTab, setChatTab] = useState("accepted");
  const [chatList, setChatList] = useState([]);
  const acceptedChats = chatList.filter((item) => item.status === "accepted");
  const sortedAcceptedChats = acceptedChats.slice().sort((a, b) => {
    if (a.is_admin !== b.is_admin) return b.is_admin - a.is_admin;
    return new Date(b.last_message_created_at) - new Date(a.last_message_created_at);
  });

  const requestChats = chatList.filter((item) => item.status === "requested");
  const blockedChats = chatList.filter((item) => item.status === "blocked");
  const requestCount = requestChats.length;

  const [relationship, setRelationship] = useState("");

  const selectedUser =
    chatList.find((chat) => chat.hcc_id === otherHccId) || fallbackUser;

  useEffect(() => {
    const loadFallbackUser = async () => {
      if (!otherHccId || chatList.some((c) => c.hcc_id === otherHccId)) return;

      const { data, error } = await supabase
        .from("users")
        .select(
          "hcc_id, first_name, last_name, profile_pic_url, is_online, last_active_at"
        )
        .eq("hcc_id", otherHccId)
        .single();

      if (error) {
        console.error("Failed to fetch fallback user:", error.message);
      } else {
        setFallbackUser(data);
      }
    };

    loadFallbackUser();
  }, [chatList, otherHccId]);

  useEffect(() => {
    const fetchStatus = async () => {
      const { data, error } = await supabase
        .from("user_relationships")
        .select("*")
        .eq("sender_id", otherHccId)
        .eq("receiver_id", myHccId)
        .maybeSingle();
      console.log("Fetched relationship data:", data);
      console.log("Supabase error:", error);

      if (data) setRelationship(data);
    };

    if (otherHccId) {
      fetchStatus();
    }
  }, [otherHccId]);

  console.log("acceepedChats", acceptedChats);
  console.log("requestChats", requestChats);

  const fetchChatList = async () => {
    console.log("[RPC] Fetching chat list for:", myHccId);

    const { data, error } = await supabase.rpc("get_chat_list", {
      my_hcc_id: myHccId,
    });

    if (error) {
      console.error("[RPC] get_chat_list error:", error.message);
      return;
    }

    if (!data || data.length === 0) {
      console.warn("[RPC] No chat data returned");
      return;
    }
    setChatList(data); // <-- here

    console.log("[RPC] Chat list loaded:", data);
  };

  useEffect(() => {
    if (myHccId) {
      fetchChatList();
    }
  }, [myHccId]);

  const handleRelationshipAction = async (senderId, action) => {
    const myHccId = localStorage.getItem("hcc_id");
    const newStatus = action === "accept" ? "accepted" : "blocked";

    const { error } = await supabase.rpc("update_relationship_status", {
      sender_id_input: senderId,
      receiver_id_input: myHccId,
      new_status: newStatus,
    });

    if (error) {
      console.error(`[Action Failed] ${action} user error:`, error.message);
      alert("Something went wrong. Please try again.");
    } else {
      console.log(`[Action Success] Relationship ${newStatus} with`, senderId);
      // Optional: refetch chat list or update state
      setRelationship((prev) => ({
        ...prev,
        status: newStatus,
      }));

      fetchChatList(); // assuming you have this in scope
    }
  };

  useEffect(() => {
    console.log("[Realtime Setup] Listening for new incoming messages...");

    const channel = supabase
      .channel("chat-realtime-listener")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "messages",
          filter: `receiver_id=eq.${myHccId}`,
        },
        async (payload) => {
          const newMsg = payload.new;
          console.log("[Realtime] New message received:", newMsg);

          const alreadyInList = chatList.find(
            (c) => c.hcc_id === newMsg.sender_id
          );

          if (!alreadyInList) {
            console.log("[Realtime] New sender. Fetching preview...");
            const { data, error } = await supabase.rpc("get_chat_preview", {
              my_hcc_id: myHccId,
              other_hcc_id: newMsg.sender_id,
            });

            if (error) {
              console.error(
                "[Realtime] Failed to fetch preview:",
                error.message
              );
            } else if (data?.length) {
              const newEntry = {
                ...data[0],
                hcc_id: data[0].sender_id || data[0].other_hcc_id,
              };

              setChatList((prev) => {
                const exists = prev.some(
                  (chat) => chat.hcc_id === newEntry.hcc_id
                );
                if (!exists) {
                  console.log(
                    "[Realtime] Adding new sender to chat list:",
                    newEntry
                  );
                  return [...prev, newEntry];
                }
                return prev;
              });
            }
          } else {
            // ✅ Auto-mark as read if user is already viewing this chat
            if (otherHccId === newMsg.sender_id) {
              await supabase
                .from("messages")
                .update({ read_at: new Date().toISOString() })
                .eq("id", newMsg.id);
            }

            setChatList((prev) =>
              prev.map((c) =>
                c.hcc_id === newMsg.sender_id
                  ? {
                    ...c,
                    unread_count:
                      otherHccId === newMsg.sender_id
                        ? 0
                        : (c.unread_count || 0) + 1,
                    last_message_content: newMsg.content,
                    last_message_created_at: newMsg.created_at,
                  }
                  : c
              )
            );
          }
        }
      )
      .subscribe();

    return () => {
      console.log("[Realtime Cleanup] Removing channel");
      supabase.removeChannel(channel);
    };
  }, [myHccId, chatList, otherHccId]);

  console.log("RequestChats Length:", requestChats.length);
  const seen = new Set();
  requestChats.forEach((chat, i) => {
    console.log(
      `#${i} → ${chat.hcc_id}`,
      seen.has(chat.hcc_id) ? "🚨 DUPLICATE" : ""
    );
    seen.add(chat.hcc_id);
  });
  useEffect(() => {
    console.log(
      "[chatList] Current IDs:",
      chatList.map((c) => c.hcc_id)
    );
  }, [chatList]);

  return (
    <>
      <CustomTop />
      <div className="search-screen-container search-page">
        <Navbar />
        <div className="content-area chat-container">
          <div className={otherHccId ? "hidden chat-list" : "chat-list"}>
            <div className="chat-tabs">
              <button
                className={
                  chatTab === "accepted" ? "tab-button active" : "tab-button"
                }
                onClick={() => setChatTab("accepted")}
              >
                All Chats
              </button>
              <button
                className={chatTab === "requested" ? "tab-button active" : "tab-button"}
                onClick={() => setChatTab("requested")}
              >
                Requests
                {requestCount > 0 && (
                  <span
                    style={{
                      marginLeft: 8,
                      background: "red",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 8px",
                      fontSize: "0.8em",
                      fontWeight: "bold",
                    }}
                  >
                    {requestCount}
                  </span>
                )}
              </button>

              <button
                className={
                  chatTab === "blocked" ? "tab-button active" : "tab-button"
                }
                onClick={() => setChatTab("blocked")}
              >
                Blocked
              </button>
            </div>

            <div className="searchbar">
              <input type="search" placeholder="Search for people" />
              <BiSearch size={25} color="#9D9D9D" />
            </div>

            <div className="chat-items">
              {chatTab === "requested" && (
                <>
                  {requestChats.map((item) => (
                    <div
                      onClick={() => navigate(`/messages/${item.hcc_id}`)}
                      style={{
                        padding: "10px",
                        background:
                          otherHccId === item.hcc_id ? "#f0e6ff" : "#fff",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={
                          item?.profile_pic_url ||
                          require("../Components/Post/images/male.jpg")
                        }
                        alt="user"
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: 10,
                          objectFit: "cover",
                        }}
                      />

                      <div>
                        <strong>{item?.first_name}</strong>
                        <div className="last-message-time">
                          <p
                            style={{
                              margin: 0,
                              fontSize: "0.85em",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "180px", // adjust as per layout
                            }}
                          >
                            {" "}
                            {item.last_message_content}
                          </p>
                          <div style={{ fontSize: "0.75em", color: "#777" }}>
                            {item.last_message_created_at &&
                              new Date(
                                item.last_message_created_at
                              ).toLocaleString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                          </div>
                        </div>
                      </div>
                      {item.unread_count > 0 && (
                        <div
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "0.75em",
                            marginLeft: 8,
                            alignSelf: "center",
                          }}
                        >
                          {item.unread_count}
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
              {chatTab === "accepted" && (
                <>
                  {sortedAcceptedChats.map((item) => (
                    <div
                      key={item.hcc_id}
                      onClick={() => navigate(`/messages/${item.hcc_id}`)}
                      style={{
                        padding: "10px",
                        background:
                          otherHccId === item.hcc_id ? "#f0e6ff" : "#fff",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={
                          item?.profile_pic_url ||
                          require("../Components/Post/images/male.jpg")
                        }
                        alt="user"
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: 10,
                          objectFit: "cover",
                        }}
                      />

                      <div>
                        <strong>{item?.first_name}</strong>
                        <div className="last-message-time">
                          <p
                            style={{
                              margin: 0,
                              fontSize: "0.85em",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "180px", // adjust as per layout
                            }}
                          >
                            {" "}
                            {item.last_message_content}
                          </p>
                          <div style={{ fontSize: "0.75em", color: "#777" }}>
                            {item.last_message_created_at &&
                              new Date(
                                item.last_message_created_at
                              ).toLocaleString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                          </div>
                        </div>
                      </div>
                      {item.unread_count > 0 && (
                        <div
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "0.75em",
                            marginLeft: 8,
                            alignSelf: "center",
                          }}
                        >
                          {item.unread_count}
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
              {chatTab === "blocked" && (
                <>
                  {blockedChats.length === 0 && (
                    <div
                      style={{
                        padding: 16,
                        textAlign: "center",
                        color: "#777",
                      }}
                    >
                      No blocked users.
                    </div>
                  )}
                  {blockedChats.map((item) => (
                    <div
                      key={item.hcc_id}
                      style={{
                        padding: "10px",
                        background: "#f8f8f8",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={
                          item?.profile_pic_url ||
                          require("../Components/Post/images/male.jpg")
                        }
                        alt="user"
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: 10,
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <strong>{item?.first_name}</strong>
                        <p style={{ fontSize: "0.85em", margin: 0 }}>
                          {item?.hcc_id}
                        </p>
                      </div>
                      <button
                        style={{
                          marginLeft: "auto",
                          background: "#4caf50",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "0.8em",
                        }}
                        onClick={() =>
                          handleRelationshipAction(item.hcc_id, "accept")
                        }
                      >
                        Unblock
                      </button>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>

          <div
            className={
              otherHccId ? "chat-window" : "message-dummy-content hidden"
            }
          >
            {!otherHccId ? (
              <div className="no-chat-selected">
                <img src={require("./images/dummy-message-symbol.png")} />
                <h2>Your Messages</h2>
                <p>Send a message to start a chat.</p>
              </div>
            ) : (
              <>
                <div className="chat-header" style={{ cursor: "pointer" }}>
                  {" "}
                  <MdOutlineArrowBackIos
                    size={20}
                    onClick={() => navigate(-1)}
                  />
                  <div
                    style={{ display: "flex", gap: "10px" }}
                    onClick={() => navigate(`/profile/${selectedUser?.hcc_id}`)}
                  >
                    <img
                      src={
                        selectedUser?.profile_pic_url ||
                        require("../Components/Post/images/male.jpg")
                      }
                      alt="user"
                      className="chat-profile-pic"
                    />
                    <div className="user-info" style={{ margin: 0 }}>
                      <div className="header-name" style={{ margin: 0 }}>
                        {selectedUser?.first_name}
                      </div>
                      <p style={{ margin: 0 }}>{selectedUser?.hcc_id}</p>
                      {(selectedUser?.is_online ||
                        selectedUser?.last_active_at) && (
                          <p className="status" style={{ margin: 0 }}>
                            {selectedUser?.is_online
                              ? "Online"
                              : `Last seen: ${formatLastSeen(
                                selectedUser.last_active_at
                              )}`}
                          </p>
                        )}
                    </div>
                  </div>
                  <button
                    style={{
                      padding: "5px 5px",
                      backgroundColor: "#ff4d4f",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      transition: "background-color 0.3s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#d9363e")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#ff4d4f")
                    }
                    onClick={() =>
                      handleRelationshipAction(otherHccId, "block")
                    }
                  >
                    Block
                  </button>{" "}
                </div>
                <Disclaimer />

                <div className="chat-body" ref={chatRef}>
                  {(() => {
                    let lastRenderedDate = null;

                    return messages.map((msg) => {
                      const sender =
                        chatList.find((u) => u.hcc_id === msg.sender_id) ||
                        (msg.sender_id === fallbackUser?.hcc_id
                          ? fallbackUser
                          : null);
                      const isMine = msg.sender_id === myHccId;

                      const msgDate = new Date(msg.created_at);
                      const msgDateStr = msgDate.toDateString();

                      let showDateDivider = false;
                      if (msgDateStr !== lastRenderedDate) {
                        lastRenderedDate = msgDateStr;
                        showDateDivider = true;
                      }

                      const time = msgDate.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true, // 👈 this ensures AM/PM
                      });

                      const getDateLabel = (date) => {
                        const today = new Date();
                        const yesterday = new Date();
                        yesterday.setDate(today.getDate() - 1);

                        if (date.toDateString() === today.toDateString())
                          return "Today";
                        if (date.toDateString() === yesterday.toDateString())
                          return "Yesterday";

                        return date.toLocaleDateString(undefined, {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        });
                      };

                      return (
                        <React.Fragment key={msg.id}>
                          {showDateDivider && (
                            <div className="date-divider">
                              {getDateLabel(msgDate)}
                            </div>
                          )}

                          <div
                            className={`chat-message ${isMine ? "sent" : "received"
                              }`}
                          >
                            {!isMine && (
                              <img
                                src={
                                  sender?.profile_pic_url ||
                                  require("../Components/Post/images/male.jpg")
                                }
                                className="profile-pic-small"
                                alt="sender"
                              />
                            )}
                            <div className="message-bubble">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: convertLinks(msg.content),
                                }}
                              />
                              <div className="msg-time">{time}</div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    });
                  })()}
                </div>
                {relationship?.status === "requested" ? (
                  <div style={{ padding: "1rem", textAlign: "center" }}>
                    <p style={{ marginBottom: 12 }}>
                      This user wants to chat with you.
                    </p>
                    <button
                      className="btn btn-success m-2"
                      onClick={() =>
                        handleRelationshipAction(
                          relationship.sender_id,
                          "accept"
                        )
                      }
                    >
                      Accept
                    </button>
                    <button
                      className="btn btn-danger m-2"
                      onClick={() =>
                        handleRelationshipAction(
                          relationship.sender_id,
                          "block"
                        )
                      }
                    >
                      Block
                    </button>
                  </div>
                ) : relationship?.status === "blocked" ? (
                  <div style={{ padding: "1rem", textAlign: "center" }}>
                    <p style={{ marginBottom: 12 }}>
                      You have blocked this user. You won't receive messages
                      unless you unblock them.
                    </p>
                    <button
                      className="btn btn-success"
                      onClick={() =>
                        handleRelationshipAction(
                          relationship.sender_id,
                          "accept"
                        )
                      }
                    >
                      Unblock
                    </button>
                  </div>
                ) : (
                  <div className="message-input">
                    <textarea
                      rows={1}
                      ref={textareaRef}
                      placeholder="Type here..."
                      value={messageText}
                      onChange={(e) => {
                        setMessageText(e.target.value);
                        handleTextareaInput();
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          UpgradeCheck();
                        }
                      }}
                    />
                    <button
                      className="bg-[#e6d4fb] hover:bg-[#d3baf7] text-gray-600 font-medium 
    px-3 py-1.5 rounded-xl"
                      onClick={UpgradeCheck}
                    >
                      Send
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* <Footer /> */}
        {UpgradeShow && (
          <UpgradePage
            UpgradeShow={UpgradeShow}
            setUpgradeShow={setUpgradeShow}
            ScreenVisbile={ScreenVisbile}
            setScreenVisbile={setScreenVisbile}
            handleUpgradeClose={handleUpgradeClose}
          />
        )}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={profilePic}
          onHide={handleprofilpicclose}
          className="edit-profile-popup"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add your profile to get started</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditDp
              handleLoginEvent={handleprofilpicclose}
              showApply={showApply}
              setshowApply={setshowApply}
            />
          </Modal.Body>
        </Modal>
        {showApply && (
          <CraftsModal
            showApply={showApply}
            setshowApply={setshowApply}
            handleClose={handleClose}
          />
        )}
      </div>
    </>
  );
};

export { MessagesPage };
